// extracted by mini-css-extract-plugin
module.exports = {"container":"MenuSwitch_container__TwYpB","inactive":"MenuSwitch_inactive__7_dvd","active":"MenuSwitch_active__3OZrc"};